export default "__VITE_ASSET__CsXUHDEp__"